// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2GjuO","unreadBadge":"styles_unreadBadge__EOrJM","modalContent":"styles_modalContent__1F6BT","modal":"styles_modal__sg8Yb"};